import { useContext, useState, useEffect } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { post } from "../../adapters/xhr/api";
import MainContent from "../../layouts/maincontent/MainContent";
import InputElement from "../../shared/form/InputElement";
import stylesRequestData from "../../components/taxAppeal/appealRequestData/RequestData.module.css";
import TextAreaElement from "../../shared/form/TextAreaElement";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import UnifiedTaxDeclarationContext from "../../contexts/UnifiedTaxDeclarationProvider";

import {
  getAppealRequestDetails,
  previewAndDownloadAppealFile,
} from "../../adapters/apis/taxAppeal/details";

const UnifiedTaxDeclarationDetails = () => {
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const { declarationRequest, setDeclarationRequest, user, setUser } =
    unifiedTaxDeclarationContext;
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [backendError, setBackendError] = useState(null);
  const [showSucessMessage, setShowSucessMessage] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsLoading(true);
        try {
          const response = await getAppealRequestDetails(id);
          setDeclarationRequest(response?.data?.data);
          setUser((prev) => ({
            ...prev,
            first_name: response?.data?.data?.user?.profile.first_name,
            father_name: response?.data?.data?.user?.profile.second_name,
            grandfather_name: response?.data?.data?.user?.profile.third_name,
            family_name: response?.data?.data?.user?.profile.fourth_name,
            email: response?.data?.data?.user?.email,
            phone_number: response?.data?.data?.user?.profile.mobile,
            nationality: {
              id: response?.data?.data?.user?.profile.nationality.id,
              key: response?.data?.data?.user?.profile.nationality.code,
              value: response?.data?.data?.user?.profile.nationality.name,
            },
            national_id: response?.data?.data?.user?.profile.national_id,
            passport_number: response?.data?.data?.user?.profile.passport_num,
            building_number:
              response?.data?.data?.user?.profile.real_estate_num,
            governorate_id: response?.data?.data?.user?.profile.governorate_id,
            district_id: response?.data?.data?.user?.profile.district_id,
            village_id: response?.data?.data?.user?.profile.village_id,
            street_id: response?.data?.data?.user?.profile.street_id ?? -1,
            street_other: response?.data?.data?.user?.profile.street_other,
            national_id_file:
              response?.data?.data?.user?.profile.national_id_file?.[0] || null,
            passport_number_file:
              response?.data?.data?.user?.profile.passport_num_file?.[0] ||
              null,
            profile: response?.data?.data?.user?.profile,
          }));
          setIsLoading(false);
        } catch (error) {
          navigate("/NotFound");
        }
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    // TODO change it to temp Id
    if (
      location.pathname.includes("/tax-appeal/temporary") &&
      !declarationRequest?.applicant_role_id
    ) {
      navigate("/tax-appeal/list-data");
    }
  }, []);

  const handlePreviewFile = async (url) => {
    try {
      const response = await previewAndDownloadAppealFile(url);

      const blob = new Blob([response?.data], {
        type: response.headers["content-type"],
      });

      // Create a URL for the blob
      const fileUrl = URL.createObjectURL(blob);
      window.open(fileUrl, "_blank");
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const handleDownloadFile = async (url) => {
    try {
      const response = await previewAndDownloadAppealFile(url);

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      // Extract filename from Content-Disposition header
      let fileName = "file"; // Default filename
      let originFileName = "file";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(/filename="(.+?)"/);
        if (match) {
          originFileName = match[1];
        }
      }

      const mimeType = blob.type;
      const ext = originFileName.split(".").pop().toLowerCase();

      if (ext === "jfif" || mimeType === "image/jfif") {
        fileName = "file.jfif";
      } else if (mimeType === "image/jpeg" || mimeType === "image/jpg") {
        fileName = ext === "jpg" ? "file.jpg" : "file.jpeg";
      }

      // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName.replace(/"/g, ""); // Remove any quotes
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const handleSubmit = async (e) => {
    setIsSubmitting(true);
    e.preventDefault();
    setBackendError(null);

    try {
      if (declarationRequest?.editMode) {
        declarationRequest.appeal_request_id = declarationRequest?.id;

        const response = await post(
          `api/tax-appeal/${declarationRequest?.id}/update-request`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
          declarationRequest,
        );
        window.scrollTo(0, 0);
        setShowSucessMessage(true);
        setTimeout(() => {
          setShowSucessMessage(false);
          initiatePayment(response);
        }, 5000);
      } else if (id && !declarationRequest?.editMode) {
        const response = await post(
          `api/tax-appeal/pay/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
          declarationRequest,
        );
        window.scrollTo(0, 0);
        setShowSucessMessage(true);
        setTimeout(() => {
          setShowSucessMessage(false);
          initiatePayment(response);
        }, 5000);
      } else {
        // if (
        //   declarationRequest?.disableAfterPaymentDifferentPeriod ||
        //   declarationRequest?.disableAfterPaymentSameBuilding
        // ) {
        //   declarationRequest.linked_id = declarationRequest?.id;
        // }

        delete declarationRequest?.id;
        const response = await post(
          "api/tax-appeal/submit-request",
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
          declarationRequest,
        );
        window.scrollTo(0, 0);
        setShowSucessMessage(true);
        setTimeout(() => {
          setShowSucessMessage(false);
          initiatePayment(response);
        }, 5000);
      }

      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);

      setBackendError(
        error.response?.data?.data?.message || "خطأ في إرسال البيانات",
      );
      window.scrollTo(0, 0);
    }
  };

  const initiatePayment = (response) => {
    document.initiationForm.action = response?.data?.data?.payment_gateway_url;
    document.getElementById("SenderID").value = response?.data?.data?.sender_id;
    document.getElementById("RandomSecret").value =
      response?.data?.data?.random_secret;
    document.getElementById("RequestObject").value =
      response?.data?.data?.request_object;
    document.getElementById("HashedRequestObject").value =
      response?.data?.data?.hashed_request_object;
    document.getElementById("initiationForm").submit();
    window.scrollTo(0, 0);
  };

  return (
    <>
      <MainContent>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <form
              method="POST"
              id="initiationForm"
              name="initiationForm"
              action=""
            >
              <input type="hidden" name="SenderID" id="SenderID" value="" />
              <input
                type="hidden"
                name="RandomSecret"
                id="RandomSecret"
                value=""
              />
              <input
                type="hidden"
                name="RequestObject"
                id="RequestObject"
                value=""
              />
              <input
                type="hidden"
                name="HashedRequestObject"
                id="HashedRequestObject"
                value=""
              />
            </form>

            <section className={`section-content pt-md-0 pt-4 pb-5`}>
              <div className={`container`}>
                {backendError && (
                  <div
                    className="alert alert-danger text-center mt-3"
                    id="backend_error"
                    role="alert"
                  >
                    {backendError}
                  </div>
                )}

                {showSucessMessage && (
                  <div className="alert alert-success text-success mt-2 text-center w-50 mx-auto">
                    <h3 className="fs-5">
                      لقد تم إنشاء طلبك بنجاح، يرجى سداد الرسوم لإستكمال تقديم
                      طلب الطعن
                    </h3>
                  </div>
                )}
                <div className="d-flex align-items-center">
                  <h3 className="box-title mb-0 fw-bold ml-2">
                    {!declarationRequest?.id
                      ? "مراجعة الطلب المقدم"
                      : "تفاصيل الطلب"}
                  </h3>
                </div>

                <div className={`card-box`}>
                  {/* buttons */}
                  <div className={`box-content`}>
                    <div className={`box`}>
                      <h4 className={`box-title mb-4`}>بيانات الطلب</h4>
                      {!declarationRequest?.id && (
                        <div className="row">
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="appeal_type_text"
                              name="appeal_type_text"
                              labelClassName={`form-label`}
                              labelText="نوع الطلب"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="appeal_type_text_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.appeal_type_text || ""}
                              disabled={true}
                            />
                          </div>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="form_number"
                              name="form_number"
                              labelClassName={`form-label`}
                              labelText="رقم النموذج"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="form_number_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.form_number || ""}
                              disabled={true}
                            />
                          </div>
                        </div>
                      )}
                      {declarationRequest?.id && (
                        <div className="row">
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="form_number"
                              name="form_number"
                              labelClassName={`form-label`}
                              labelText="رقم النموذج"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="form_number_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.form_number || ""}
                              disabled={true}
                            />
                          </div>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="appeal_type_text"
                              name="appeal_type_text"
                              labelClassName={`form-label`}
                              labelText="نوع الطلب"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="appeal_type_text_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.appeal_type_text || ""}
                              disabled={true}
                            />
                          </div>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="request_number"
                              name="request_number"
                              labelClassName={`form-label`}
                              labelText="رقم الطلب"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="request_number"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.request_number || ""}
                              disabled={true}
                            />
                          </div>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="created_at"
                              name="created_at"
                              labelClassName={`form-label`}
                              labelText="تاريخ تقديم الطلب"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="created_at"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.created_at || ""}
                              disabled={true}
                            />
                          </div>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="status_text"
                              name="status_text"
                              labelClassName={`form-label`}
                              labelText="حالة الطلب"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="status_text"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.status_text || ""}
                              disabled={true}
                            />
                          </div>
                          {[3, 4, 5, 6].includes(
                            parseInt(declarationRequest?.status),
                          ) && (
                            <>
                              <div className="col-md-4">
                                <InputElement
                                  mb4="mb-4"
                                  labelHtmlFor="appeal_committee_text"
                                  name="appeal_committee_text"
                                  labelClassName={`form-label`}
                                  labelText="اللجنة المختصة"
                                  inputType="text"
                                  inputClassName={`form-control font-grey`}
                                  inputID="appeal_committee_text"
                                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                  value={
                                    declarationRequest?.appeal_committee_text ||
                                    ""
                                  }
                                  disabled={true}
                                />
                              </div>
                              <div className="col-md-4">
                                <InputElement
                                  mb4="mb-4"
                                  labelHtmlFor="deposit_date"
                                  name="deposit_date"
                                  labelClassName={`form-label`}
                                  labelText="تاريخ الإيداع"
                                  inputType="text"
                                  inputClassName={`form-control font-grey`}
                                  inputID="deposit_date"
                                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                  value={declarationRequest?.deposit_date || ""}
                                  disabled={true}
                                />
                              </div>
                              <div className="col-md-4">
                                <InputElement
                                  mb4="mb-4"
                                  labelHtmlFor="appeal_session_date"
                                  name="appeal_session_date"
                                  labelClassName={`form-label`}
                                  labelText="تاريخ أول جلسة"
                                  inputType="text"
                                  inputClassName={`form-control font-grey`}
                                  inputID="appeal_session_date"
                                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                  value={
                                    declarationRequest?.appeal_session_date ||
                                    ""
                                  }
                                  disabled={true}
                                />
                              </div>
                            </>
                          )}

                          {declarationRequest?.appeal_resolving_date && (
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="appeal_resolving_date"
                                name="appeal_resolving_date"
                                labelClassName={`form-label`}
                                labelText="تاريخ البت في الطعن"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="appeal_resolving_date"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={
                                  declarationRequest?.appeal_resolving_date ||
                                  ""
                                }
                                disabled={true}
                              />
                            </div>
                          )}

                          {declarationRequest?.appeal_insurance_fees_payment_receipt && (
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="appeal_insurance_fees_payment_receipt"
                                name="appeal_insurance_fees_payment_receipt"
                                labelClassName={`form-label`}
                                labelText="إيصال سداد تأمين الطعن"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="appeal_insurance_fees_payment_receipt_input"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={
                                  declarationRequest?.appeal_insurance_fees_payment_receipt
                                    ? "الملف"
                                    : ""
                                }
                                isIcon={
                                  declarationRequest?.appeal_insurance_fees_payment_receipt ||
                                  ""
                                }
                                disabled={true}
                                idDownload={id}
                                filedDownload="appealInsuranceFeesPaymentReceipt"
                                serverSide={true}
                                previewFunction={() =>
                                  handlePreviewFile(
                                    declarationRequest
                                      ?.appeal_insurance_fees_payment_receipt
                                      ?.full_url,
                                  )
                                }
                                downloadFunction={() =>
                                  handleDownloadFile(
                                    declarationRequest
                                      ?.appeal_insurance_fees_payment_receipt
                                      ?.full_url,
                                  )
                                }
                              />
                            </div>
                          )}

                          {declarationRequest?.appeal_insurance_fees_deposit_receipt && (
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="appeal_insurance_fees_deposit_receipt"
                                name="appeal_insurance_fees_deposit_receipt"
                                labelClassName={`form-label`}
                                labelText="إيصال إيداع الطعن"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="appeal_insurance_fees_deposit_receipt_input"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={
                                  declarationRequest?.appeal_insurance_fees_deposit_receipt
                                    ? "الملف"
                                    : ""
                                }
                                isIcon={
                                  declarationRequest?.appeal_insurance_fees_deposit_receipt ||
                                  ""
                                }
                                disabled={true}
                                idDownload={id}
                                filedDownload="appealInsuranceFeesDepositReceipt"
                                serverSide={true}
                                previewFunction={() =>
                                  handlePreviewFile(
                                    declarationRequest
                                      ?.appeal_insurance_fees_deposit_receipt
                                      ?.full_url,
                                  )
                                }
                                downloadFunction={() =>
                                  handleDownloadFile(
                                    declarationRequest
                                      ?.appeal_insurance_fees_deposit_receipt
                                      ?.full_url,
                                  )
                                }
                              />
                            </div>
                          )}

                          {declarationRequest?.real_estate_tax_form_no_5 &&
                            parseInt(declarationRequest?.status) === 6 && (
                              <>
                                <div className="col-md-4">
                                  <InputElement
                                    mb4="mb-4"
                                    labelHtmlFor="real_state_tax_form_no_5"
                                    name="real_state_tax_form_no_5"
                                    labelClassName={`form-label`}
                                    labelText="نموذج 5 ض.ع"
                                    inputType="text"
                                    inputClassName={`form-control font-grey`}
                                    inputID="real_state_tax_form_no_5"
                                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                    value={
                                      declarationRequest?.real_estate_tax_form_no_5
                                        ? "الملف"
                                        : ""
                                    }
                                    isIcon={
                                      declarationRequest?.real_estate_tax_form_no_5 ||
                                      ""
                                    }
                                    disabled={true}
                                    idDownload={id}
                                    filedDownload="realStateTaxFormNo5"
                                    serverSide={true}
                                    previewFunction={() =>
                                      handlePreviewFile(
                                        declarationRequest
                                          ?.real_estate_tax_form_no_5?.full_url,
                                      )
                                    }
                                    downloadFunction={() =>
                                      handleDownloadFile(
                                        declarationRequest
                                          ?.real_estate_tax_form_no_5?.full_url,
                                      )
                                    }
                                  />
                                </div>

                                {declarationRequest?.decision && (
                                  <div className="col-md-4">
                                    <InputElement
                                      mb4="mb-4"
                                      labelHtmlFor="decision"
                                      name="decision"
                                      labelClassName={`form-label`}
                                      labelText="القرار"
                                      inputType="text"
                                      inputClassName={`form-control font-grey`}
                                      inputID="decision"
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      value={declarationRequest?.decision || ""}
                                      disabled={true}
                                    />
                                  </div>
                                )}
                              </>
                            )}
                        </div>
                      )}
                    </div>
                    <div className={`box`}>
                      <h4 className={`box-title mb-4`}>بيانات مقدم الطعن </h4>
                      <div className="row">
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="submitter_type_text"
                            name="submitter_type_text"
                            labelClassName={`form-label`}
                            labelText="صفة مقدم الطلب"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="submitter_type_text_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={
                              declarationRequest?.submitter_type_text || ""
                            }
                            disabled={true}
                          />
                        </div>
                        {parseInt(declarationRequest?.applicant_role_id) ===
                          6 && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="applicant_role_other"
                              name="applicant_role_other"
                              labelClassName={`form-label`}
                              labelText="أخرى"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="submitter_type_text_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                declarationRequest?.applicant_role_other || ""
                              }
                              disabled={true}
                            />
                          </div>
                        )}
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="tax_payer_first_name"
                            name="tax_payer_first_name"
                            labelClassName={`form-label`}
                            labelText="الإسم الأول لمقدم الطعن"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="tax_payer_first_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={user?.first_name || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="tax_payer_rest_name"
                            name="tax_payer_rest_name"
                            labelClassName={`form-label`}
                            labelText="باقي الإسم لمقدم الطعن"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="tax_payer_rest_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={
                              `${user?.father_name ? user?.father_name : ""} ${
                                user?.grandfather_name
                                  ? user?.grandfather_name
                                  : ""
                              } ${
                                user?.family_name ? user?.family_name : ""
                              }` || ""
                            }
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="email"
                            name="email"
                            labelClassName={`form-label`}
                            labelText="البريد الإلكترونى"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="email"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={user?.email || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="phone_number"
                            name="phone_number"
                            labelClassName={`form-label`}
                            labelText="رقم الهاتف"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="phone_number"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={user?.phone_number || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="natioanlity"
                            name="natioanlity"
                            labelClassName={`form-label`}
                            labelText="جنسية مقدم الطلب"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="natioanlity"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={user?.nationality?.value || ""}
                            disabled={true}
                          />
                        </div>

                        {/* if the nationality is egyptian */}
                        {user?.nationality?.id &&
                        user?.nationality?.id ===
                          declarationRequest?.egypt_nationality_id ? (
                          <>
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="national_id"
                                name="national_id"
                                labelClassName={`form-label`}
                                labelText="الرقم القومي لمقدم الطلب"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="national_id"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={user?.national_id || ""}
                                disabled={true}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            {user?.nationality?.id && (
                              <div className="col-md-4">
                                <InputElement
                                  mb4="mb-4"
                                  labelHtmlFor="passport_number"
                                  name="passport_number"
                                  labelClassName={`form-label`}
                                  labelText="رقم  جواز السفر لمقدم الطلب"
                                  inputType="text"
                                  inputClassName={`form-control font-grey`}
                                  inputID="passport_number_input"
                                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                  value={user?.passport_number || ""}
                                  disabled={true}
                                />
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    {[4, 5, 6].includes(
                      parseInt(declarationRequest?.applicant_role_id),
                    ) && (
                      <>
                        <div className={`box`}>
                          <h4 className={`box-title mb-4`}>
                            بيانات مالك الوحدة محل الطعن
                          </h4>
                          <div className="row">
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="unit_owner_type_text"
                                name="unit_owner_type_text"
                                labelClassName={`form-label`}
                                labelText="نوع مالك الوحدة محل الطعن"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="unit_owner_type_text_input"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={
                                  declarationRequest?.unit_owner_type_text || ""
                                }
                                disabled={true}
                              />
                            </div>

                            {parseInt(
                              declarationRequest?.unit_owner_type_id,
                            ) === 1 && (
                              <>
                                <div className="col-md-4">
                                  <InputElement
                                    mb4="mb-4"
                                    labelHtmlFor="unit_owner_first_name"
                                    name="unit_owner_first_name"
                                    labelClassName={`form-label`}
                                    labelText="الإسم الأول لمالك الوحدة محل الطعن"
                                    inputType="text"
                                    inputClassName={`form-control font-grey`}
                                    inputID="unit_owner_first_name"
                                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                    value={
                                      declarationRequest?.unit_owner_first_name ||
                                      ""
                                    }
                                    disabled={true}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <InputElement
                                    mb4="mb-4"
                                    labelHtmlFor="unit_owner_rest_name"
                                    name="unit_owner_rest_name"
                                    labelClassName={`form-label`}
                                    labelText="باقي الإسم لمالك الوحدة محل الطعن"
                                    inputType="text"
                                    inputClassName={`form-control font-grey`}
                                    inputID="unit_owner_rest_name"
                                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                    value={
                                      declarationRequest?.unit_owner_rest_name ||
                                      ""
                                    }
                                    disabled={true}
                                  />
                                </div>

                                <div className="col-md-4">
                                  <InputElement
                                    mb4="mb-4"
                                    labelHtmlFor="unit_owner_nationality_text"
                                    name="unit_owner_nationality_text"
                                    labelClassName={`form-label`}
                                    labelText="الجنسية"
                                    inputType="text"
                                    inputClassName={`form-control font-grey`}
                                    inputID="unit_owner_nationality_text_input"
                                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                    value={
                                      declarationRequest?.unit_owner_nationality_text ||
                                      ""
                                    }
                                    disabled={true}
                                  />
                                </div>

                                {/* if the nationality is egyptian */}
                                {[63].includes(
                                  parseInt(
                                    declarationRequest?.unit_owner_nationality_id,
                                  ),
                                ) ? (
                                  <>
                                    <div className="col-md-4">
                                      <InputElement
                                        mb4="mb-4"
                                        labelHtmlFor="unit_owner_national_id"
                                        name="unit_owner_national_id"
                                        labelClassName={`form-label`}
                                        labelText="الرقم القومي لمالك الوحدة محل الطعن"
                                        inputType="text"
                                        inputClassName={`form-control font-grey`}
                                        inputID="unit_owner_national_id"
                                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                        value={
                                          declarationRequest?.unit_owner_national_id ||
                                          ""
                                        }
                                        disabled={true}
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="col-md-4">
                                      <InputElement
                                        mb4="mb-4"
                                        labelHtmlFor="unit_owner_passport_no"
                                        name="unit_owner_passport_no"
                                        labelClassName={`form-label`}
                                        labelText="رقم جواز السفر لمالك الوحدة محل الطعن"
                                        inputType="text"
                                        inputClassName={`form-control font-grey`}
                                        inputID="unit_owner_passport_no"
                                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                        value={
                                          declarationRequest?.unit_owner_passport_no ||
                                          ""
                                        }
                                        disabled={true}
                                      />
                                    </div>
                                  </>
                                )}
                              </>
                            )}

                            {parseInt(
                              declarationRequest?.unit_owner_type_id,
                            ) === 2 && (
                              <>
                                <div className="col-md-4">
                                  <InputElement
                                    mb4="mb-4"
                                    labelHtmlFor="unit_owner_name"
                                    name="unit_owner_name"
                                    labelClassName={`form-label`}
                                    labelText="اسم مالك الوحدة محل الطعن"
                                    inputType="text"
                                    inputClassName={`form-control font-grey`}
                                    inputID="unit_owner_name"
                                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                    value={
                                      declarationRequest?.unit_owner_name || ""
                                    }
                                    disabled={true}
                                  />
                                </div>
                                {declarationRequest?.commercial_registration_number && (
                                  <div className="col-md-4">
                                    <InputElement
                                      mb4="mb-4"
                                      labelHtmlFor="commercial_registration_number"
                                      name="commercial_registration_number"
                                      labelClassName={`form-label`}
                                      labelText="رقم السجل التجاري"
                                      inputType="text"
                                      inputClassName={`form-control font-grey`}
                                      inputID="commercial_registration_number_input"
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      value={
                                        declarationRequest?.commercial_registration_number ||
                                        ""
                                      }
                                      disabled={true}
                                    />
                                  </div>
                                )}

                                {declarationRequest?.tax_number && (
                                  <div className="col-md-4">
                                    <InputElement
                                      mb4="mb-4"
                                      labelHtmlFor="tax_number"
                                      name="tax_number"
                                      labelClassName={`form-label`}
                                      labelText="الرقم الضريبي"
                                      inputType="text"
                                      inputClassName={`form-control font-grey`}
                                      inputID="tax_number_input"
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      value={
                                        declarationRequest?.tax_number || ""
                                      }
                                      disabled={true}
                                    />
                                  </div>
                                )}

                                {declarationRequest?.unit_owner_other && (
                                  <div className="col-md-4">
                                    <InputElement
                                      mb4="mb-4"
                                      labelHtmlFor="unit_owner_other"
                                      name="unit_owner_other"
                                      labelClassName={`form-label`}
                                      labelText="أخرى"
                                      inputType="text"
                                      inputClassName={`form-control font-grey`}
                                      inputID="unit_owner_other_input"
                                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                      value={
                                        declarationRequest?.unit_owner_other ||
                                        ""
                                      }
                                      disabled={true}
                                    />
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    <div className={`box`}>
                      <h4 className={`box-title mb-4`}>تفاصيل الطلب </h4>
                      <div className="row">
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="unit_code"
                            name="unit_code"
                            labelClassName={`form-label`}
                            labelText="كود الوحدة"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="unit_code_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={declarationRequest?.unit_code || ""}
                            disabled={true}
                          />
                        </div>

                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="governorate_text"
                            name="governorate_text"
                            labelClassName={`form-label`}
                            labelText="المحافظة"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="governorate_text_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={declarationRequest?.governorate_text || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="district_text"
                            name="district_text"
                            labelClassName={`form-label`}
                            labelText="المأمورية / القسم"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="district_text_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={declarationRequest?.district_text || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="village_text"
                            name="village_text"
                            labelClassName={`form-label`}
                            labelText="منطقة / شياخة"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="village_text_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={declarationRequest?.village_text || ""}
                            disabled={true}
                          />
                        </div>
                        {parseInt(declarationRequest?.village_id) === -1 && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="village_other"
                              name="village_other"
                              labelClassName={`form-label`}
                              labelText="أخرى"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="village_other_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.village_other || ""}
                              disabled={true}
                            />
                          </div>
                        )}
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="street_text"
                            name="street_text"
                            labelClassName={`form-label`}
                            labelText="شارع"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="street_text_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={declarationRequest?.street_text || ""}
                            disabled={true}
                          />
                        </div>
                        {parseInt(declarationRequest?.region_id) === -1 && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="region_other"
                              name="region_other"
                              labelClassName={`form-label`}
                              labelText="أخرى"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="region_other_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.region_other || ""}
                              disabled={true}
                            />
                          </div>
                        )}
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="build_text"
                            name="build_text"
                            labelClassName={`form-label`}
                            labelText="عقار / قطعة"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="build_text_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={declarationRequest?.build_text || ""}
                            disabled={true}
                          />
                        </div>
                        {parseInt(declarationRequest?.real_estate_id) ===
                          -1 && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="real_estate_other"
                              name="real_estate_other"
                              labelClassName={`form-label`}
                              labelText="أخرى"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="real_estate_other_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                declarationRequest?.real_estate_other || ""
                              }
                              disabled={true}
                            />
                          </div>
                        )}
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="floor_text"
                            name="floor_text"
                            labelClassName={`form-label`}
                            labelText="الدور"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="floor_text_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={declarationRequest?.floor_text || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="unit_text"
                            name="unit_text"
                            labelClassName={`form-label`}
                            labelText="الوحدة"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="unit_text"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={declarationRequest?.unit_text || ""}
                            disabled={true}
                          />
                        </div>
                        {parseInt(declarationRequest?.unit_id) === -1 && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="unit_other"
                              name="unit_other"
                              labelClassName={`form-label`}
                              labelText="أخرى"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="unit_other_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={declarationRequest?.unit_other || ""}
                              disabled={true}
                            />
                          </div>
                        )}

                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="unit_type_text"
                            name="unit_type_text"
                            labelClassName={`form-label`}
                            labelText="نوع الوحدة"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="unit_type_text"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={declarationRequest?.unit_type_text || ""}
                            disabled={true}
                          />
                        </div>
                        {parseInt(declarationRequest?.unit_type_id) === 3 && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="facility_unit_type_text"
                              name="facility_unit_type_text"
                              labelClassName={`form-label`}
                              labelText="نوع المنشأة"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="facility_unit_type_text_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                declarationRequest?.facility_unit_type_text ||
                                ""
                              }
                              disabled={true}
                            />
                          </div>
                        )}
                      </div>
                      <div className="row">
                        {parseInt(declarationRequest?.appeal_type_id) === 1 && (
                          <>
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="appeal_rental_value"
                                name="appeal_rental_value"
                                labelClassName={`form-label`}
                                labelText="القيمة الإيجارية المطعون عليها"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="appeal_rental_value_input"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={
                                  declarationRequest?.appeal_rental_value || ""
                                }
                                disabled={true}
                              />
                            </div>
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="appeal_tax_value"
                                name="appeal_tax_value"
                                labelClassName={`form-label`}
                                labelText="الضريبة المطعون عليها"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="appeal_tax_value_input"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={
                                  declarationRequest?.appeal_tax_value || ""
                                }
                                disabled={true}
                              />
                            </div>
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="appealed_tax_period_type_text"
                                name="appealed_tax_period_type_text"
                                labelClassName={`form-label`}
                                labelText="الفترة الضريبية المطعون عليها"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="appealed_tax_period_type_text_input"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={
                                  declarationRequest?.appealed_tax_period_type_text ||
                                  ""
                                }
                                disabled={true}
                              />
                            </div>
                          </>
                        )}

                        {parseInt(declarationRequest?.appeal_type_id) === 2 && (
                          <>
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="appeal_reason_type_text"
                                name="appeal_reason_type_text"
                                labelClassName={`form-label`}
                                labelText="أسباب الطعن"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="appeal_reason_type_text_input"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={
                                  declarationRequest?.appeal_reason_type_text ||
                                  ""
                                }
                                disabled={true}
                              />
                            </div>
                          </>
                        )}
                      </div>
                      {parseInt(declarationRequest?.appeal_type_id) === 1 && (
                        <div className="col-md-4">
                          <TextAreaElement
                            mb4="mb-4"
                            labelHtmlFor="appeal_reasons"
                            labelClassName={` form-label ${stylesRequestData["form-label"]}`}
                            labelText="أسباب الطعن"
                            inputClassName={` ${stylesRequestData["form-control"]} form-control`}
                            inputType="text"
                            teaxtAreaID="appeal_reasons"
                            teaxtAreaClassName="form-control"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            inputId="rental_appeal_reasons_input"
                            value={declarationRequest?.appeal_reasons || ""}
                            name="appeal_reasons"
                            disabled={true}
                          />
                        </div>
                      )}
                      {parseInt(declarationRequest?.appeal_reason_type_id) ===
                        11 && (
                        <>
                          <div className="col-md-4">
                            <TextAreaElement
                              mb4="mb-4"
                              labelHtmlFor="other_appeal_reason_type_text"
                              labelClassName={` form-label ${stylesRequestData["form-label"]}`}
                              labelText="أخري"
                              inputClassName={` ${stylesRequestData["form-control"]} form-control`}
                              inputType="text"
                              teaxtAreaID="other_appeal_reason_type_text"
                              teaxtAreaClassName="form-control"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              inputId="other_appeal_reason_type_text_input"
                              value={
                                declarationRequest?.other_appeal_reason_type_text ||
                                ""
                              }
                              name="other_appeal_reason_type_text"
                              disabled={true}
                            />
                          </div>
                        </>
                      )}
                    </div>

                    <div className={`box`}>
                      <h4 className={`box-title mb-4`}>
                        قائمة المرفقات الإلزامية الداعمة للطلب
                      </h4>
                      <div className="row">
                        {user?.national_id_file && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="passport_number_file"
                              name="passport_number_file"
                              labelClassName={`form-label`}
                              labelText="صورة الرقم القومي لمقدم الطلب"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="appeal_form_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={user?.national_id_file ? "الملف" : ""}
                              isIcon={user?.national_id_file || ""}
                              disabled={true}
                              idDownload={id}
                              filedDownload="passportNumFile"
                              serverSide={true}
                              previewFunction={() =>
                                handlePreviewFile(
                                  user?.national_id_file?.full_url,
                                )
                              }
                              downloadFunction={() =>
                                handleDownloadFile(
                                  user?.national_id_file?.full_url,
                                )
                              }
                            />
                          </div>
                        )}
                        {user?.passport_number_file && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="passport_number_file"
                              name="passport_number_file"
                              labelClassName={`form-label`}
                              labelText="صورة جواز السفر لمقدم الطلب"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="appeal_form_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={user?.passport_number_file ? "الملف" : ""}
                              isIcon={user?.passport_number_file || ""}
                              disabled={true}
                              idDownload={id}
                              filedDownload="passportNumFile"
                              serverSide={true}
                              previewFunction={() =>
                                handlePreviewFile(
                                  user?.passport_number_file?.full_url,
                                )
                              }
                              downloadFunction={() =>
                                handleDownloadFile(
                                  user?.passport_number_file?.full_url,
                                )
                              }
                            />
                          </div>
                        )}
                        {[4, 5, 6].includes(
                          parseInt(declarationRequest?.applicant_role_id),
                        ) &&
                          declarationRequest?.legal_representative_attachment && (
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="legal_representative_attachment"
                                name="legal_representative_attachment"
                                labelClassName={`form-label`}
                                labelText="صورة سند التوكيل/ سند التمثيل القانوني"
                                inputType="text"
                                inputClassName={`form-control font-grey`}
                                inputID="legal_representative_attachment_input"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                value={
                                  declarationRequest?.legal_representative_attachment
                                    ? "الملف"
                                    : ""
                                }
                                isIcon={
                                  declarationRequest?.legal_representative_attachment ||
                                  ""
                                }
                                disabled={true}
                                idDownload={id}
                                filedDownload="agencyRepresentativeDocumentFiles"
                                serverSide={true}
                                previewFunction={() =>
                                  handlePreviewFile(
                                    declarationRequest
                                      ?.legal_representative_attachment
                                      ?.full_url,
                                  )
                                }
                                downloadFunction={() =>
                                  handleDownloadFile(
                                    declarationRequest
                                      ?.legal_representative_attachment
                                      ?.full_url,
                                  )
                                }
                              />
                            </div>
                          )}

                        {declarationRequest?.unit_owner_national_id_attachment && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="unit_owner_national_id_attachment"
                              name="unit_owner_national_id_attachment"
                              labelClassName={`form-label`}
                              labelText="صورة الرقم القومي لمالك الوحدة محل الطعن"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="unit_owner_national_id_attachment_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                declarationRequest?.unit_owner_national_id_attachment
                                  ? "الملف"
                                  : ""
                              }
                              isIcon={
                                declarationRequest?.unit_owner_national_id_attachment ||
                                ""
                              }
                              disabled={true}
                              idDownload={id}
                              filedDownload="nationalIdFile"
                              serverSide={true}
                              previewFunction={() =>
                                handlePreviewFile(
                                  declarationRequest
                                    ?.unit_owner_national_id_attachment
                                    ?.full_url,
                                )
                              }
                              downloadFunction={() =>
                                handleDownloadFile(
                                  declarationRequest
                                    ?.unit_owner_national_id_attachment
                                    ?.full_url,
                                )
                              }
                            />
                          </div>
                        )}

                        {declarationRequest?.unit_owner_passport_no_attachment && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="unit_owner_passport_no_attachment"
                              name="unit_owner_passport_no_attachment"
                              labelClassName={`form-label`}
                              labelText="صورة جواز السفر لمالك الوحدة محل الطعن"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="unit_owner_passport_no_attachment"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                declarationRequest?.unit_owner_passport_no_attachment
                                  ? "الملف"
                                  : ""
                              }
                              isIcon={
                                declarationRequest?.unit_owner_passport_no_attachment ||
                                ""
                              }
                              disabled={true}
                              idDownload={declarationRequest?.profile_id}
                              filedDownload="passportNumFile"
                              serverSide={true}
                              previewFunction={() =>
                                handlePreviewFile(
                                  declarationRequest
                                    ?.unit_owner_passport_no_attachment
                                    ?.full_url,
                                )
                              }
                              downloadFunction={() =>
                                handleDownloadFile(
                                  declarationRequest
                                    ?.unit_owner_passport_no_attachment
                                    ?.full_url,
                                )
                              }
                            />
                          </div>
                        )}

                        {declarationRequest?.commercial_registration_number_attachment && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="commercial_registration_number_attachment"
                              name="commercial_registration_number_attachment"
                              labelClassName={`form-label`}
                              labelText="صورة رقم السجل التجاري"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="commercial_registration_number_attachment_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                declarationRequest?.commercial_registration_number_attachment
                                  ? "الملف"
                                  : ""
                              }
                              isIcon={
                                declarationRequest?.commercial_registration_number_attachment ||
                                ""
                              }
                              disabled={true}
                              idDownload={id}
                              filedDownload="commercialRegistrationNumberAttachment"
                              serverSide={true}
                              previewFunction={() =>
                                handlePreviewFile(
                                  declarationRequest
                                    ?.commercial_registration_number_attachment
                                    ?.full_url,
                                )
                              }
                              downloadFunction={() =>
                                handleDownloadFile(
                                  declarationRequest
                                    ?.commercial_registration_number_attachment
                                    ?.full_url,
                                )
                              }
                            />
                          </div>
                        )}

                        {declarationRequest?.tax_number_attachment && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="tax_number_attachment"
                              name="tax_number_attachment"
                              labelClassName={`form-label`}
                              labelText="صورة الرقم الضريبي"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="tax_number_attachment_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                declarationRequest?.tax_number_attachment
                                  ? "الملف"
                                  : ""
                              }
                              isIcon={
                                declarationRequest?.tax_number_attachment || ""
                              }
                              disabled={true}
                              idDownload={id}
                              filedDownload="taxNumberAttachment"
                              serverSide={true}
                              previewFunction={() =>
                                handlePreviewFile(
                                  declarationRequest?.tax_number_attachment
                                    ?.full_url,
                                )
                              }
                              downloadFunction={() =>
                                handleDownloadFile(
                                  declarationRequest?.tax_number_attachment
                                    ?.full_url,
                                )
                              }
                            />
                          </div>
                        )}

                        {declarationRequest?.unit_owner_other_attachment && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="unit_owner_other_attachment"
                              name="unit_owner_other_attachment"
                              labelClassName={`form-label`}
                              labelText="المرفق"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="unit_owner_other_attachment_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                declarationRequest?.unit_owner_other_attachment
                                  ? "الملف"
                                  : ""
                              }
                              isIcon={
                                declarationRequest?.unit_owner_other_attachment ||
                                ""
                              }
                              disabled={true}
                              idDownload={id}
                              filedDownload="unitOwnerOtherAttachment"
                              serverSide={true}
                              previewFunction={() =>
                                handlePreviewFile(
                                  declarationRequest
                                    ?.unit_owner_other_attachment?.full_url,
                                )
                              }
                              downloadFunction={() =>
                                handleDownloadFile(
                                  declarationRequest
                                    ?.unit_owner_other_attachment?.full_url,
                                )
                              }
                            />
                          </div>
                        )}

                        {declarationRequest?.appeal_form && (
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="appeal_form"
                              name="appeal_form"
                              labelClassName={`form-label`}
                              labelText={
                                parseInt(declarationRequest?.form_number) === 8
                                  ? " نموذج رقم 8"
                                  : " نموذج رقم 4"
                              }
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="appeal_form_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                declarationRequest?.appeal_form ? "الملف" : ""
                              }
                              isIcon={declarationRequest?.appeal_form || ""}
                              disabled={true}
                              idDownload={id}
                              filedDownload="appealForm"
                              serverSide={true}
                              previewFunction={() =>
                                handlePreviewFile(
                                  declarationRequest?.appeal_form?.full_url,
                                )
                              }
                              downloadFunction={() =>
                                handleDownloadFile(
                                  declarationRequest?.appeal_form?.full_url,
                                )
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={`box`}>
                      <h4 className={`box-title mb-4`}>
                        قائمة المستندات الإضافية الداعمة للطلب
                      </h4>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="has_additional_attachments_text"
                          name="has_additional_attachments_text"
                          labelClassName={`form-label`}
                          labelText="هل ترغب في تحميل المستندات الإضافية الداعمة للطلب؟"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="has_additional_attachments_text_input"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={
                            parseInt(
                              declarationRequest?.has_additional_attachments,
                            ) === 1
                              ? "نعم"
                              : "لا" || ""
                          }
                          disabled={true}
                        />
                      </div>

                      {
                        // parseInt(declarationRequest?.has_additional_attachments) ===
                        //   1 &&
                        declarationRequest?.additional_attachments?.length >
                          0 && (
                          <>
                            {declarationRequest?.additional_attachments?.map(
                              (document, index) => {
                                return (
                                  <div className="row" key={document.id}>
                                    <div className="col-md-4 col-sm-6">
                                      <InputElement
                                        mb4="mb-4"
                                        labelHtmlFor="name"
                                        name="name"
                                        labelClassName={`form-label`}
                                        labelText="اسم المستند"
                                        inputType="text"
                                        inputClassName={`form-control font-grey`}
                                        inputID="name_input"
                                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                        value={
                                          document?.name ||
                                          document?.title ||
                                          ""
                                        }
                                        disabled={true}
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6">
                                      <InputElement
                                        value={"الملف"}
                                        disabled={true}
                                        name="file"
                                        mb4="mb-4"
                                        inputType="text"
                                        labelHtmlFor="document_file"
                                        labelClassName={` form-label`}
                                        labelText="المستند"
                                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                                        inputID="document_file_input"
                                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                        isIcon={document?.full_url || ""}
                                        idDownload={document?.id}
                                        filedDownload="documentFile"
                                        serverSide={true}
                                        previewFunction={() =>
                                          handlePreviewFile(document?.full_url)
                                        }
                                        downloadFunction={() =>
                                          handleDownloadFile(document?.full_url)
                                        }
                                      />
                                    </div>
                                  </div>
                                );
                              },
                            )}
                          </>
                        )
                      }

                      {parseInt(
                        declarationRequest?.has_additional_attachments,
                      ) === 2 && (
                        <>
                          <div className="list-group border-0">
                            <label
                              htmlFor="date"
                              className={` ${stylesRequestData["list-group-item"]} list-group-item border-0`}
                            >
                              <input
                                type="checkbox"
                                className={`${stylesRequestData["form-check-input"]} form-check-input ms-3`}
                                name="acknowledge_unwillingness_submit_via_digital"
                                id="acknowledge_unwillingness_submit_via_digital"
                                checked={
                                  declarationRequest?.acknowledge_unwillingness_submit_via_digital
                                }
                              />
                              <span style={{ fontSize: "15px" }}>
                                {
                                  "أقر بعدم رغبتي في تقديم مستندات عبر المنصة الإلكترونية، وتقديمها أمام اللجنة المختصة في تاريخ أول جلسة"
                                }
                              </span>
                            </label>
                          </div>
                        </>
                      )}
                    </div>
                    <div className={`box`}>
                      <div className="list-group border-0">
                        <label
                          htmlFor="date"
                          className={` ${stylesRequestData["list-group-item"]} list-group-item border-0`}
                        >
                          <input
                            type="checkbox"
                            className={`${stylesRequestData["form-check-input"]} form-check-input ms-3`}
                            name="data_accuracy_declaration"
                            id="data_accuracy_declaration"
                            checked={
                              declarationRequest?.data_accuracy_declaration
                            }
                          />
                          <span style={{ fontSize: "15px" }}>
                            {
                              "أقر بعدم سابقة تقديم طعن ضريبي عن ذات الوحدة في ذات الفترة الضريبية"
                            }
                          </span>
                        </label>
                      </div>
                      <div className="list-group border-0">
                        <label
                          htmlFor="date"
                          className={` ${stylesRequestData["list-group-item"]} list-group-item border-0`}
                        >
                          <input
                            type="checkbox"
                            className={`${stylesRequestData["form-check-input"]} form-check-input ms-3`}
                            name="acknowledge_all_documents_are_correct"
                            id="acknowledge_all_documents_are_correct"
                            checked={
                              declarationRequest?.acknowledge_all_documents_are_correct
                            }
                          />
                          <span style={{ fontSize: "15px" }}>
                            {
                              "أقر بأن جميع الصور الضوئية للمستندات المرفقة بطلب الطعن صحيحة ومطابقة للأصل وتحت مسئوليتي، وأن جميع البيانات مدونة بمعرفتي وتحت مسئوليتي القانونية"
                            }
                          </span>
                        </label>
                      </div>
                      <div className="d-flex flex-lg-row flex-column justify-content-start  gap-3  align-items-center pb-5 mt-4">
                        {/* TODO condition to show the next 2 buttons */}
                        {((declarationRequest?.id &&
                          declarationRequest?.can_edit) ||
                          !declarationRequest?.id) && (
                          <>
                            {!isSubmitting && !showSucessMessage && (
                              <>
                                {" "}
                                <button
                                  type="button"
                                  className={` ${
                                    isSubmitting
                                      ? stylesRequestData[
                                          "btn-request-disabled"
                                        ]
                                      : stylesRequestData["btn-request"]
                                  } `}
                                  onClick={handleSubmit}
                                  id="submit_request_data"
                                  disabled={isSubmitting}
                                >
                                  سداد رسوم التأمين{" "}
                                </button>
                                <button
                                  onClick={() => {
                                    if (
                                      location.pathname.includes(
                                        "/tax-appeal/details",
                                      )
                                    ) {
                                      setDeclarationRequest((prev) => ({
                                        ...prev,
                                        editMode: true,
                                      }));
                                    }
                                    navigate("/tax-appeal/add");
                                  }}
                                  className={` ${stylesRequestData["btn-cancel"]} `}
                                  id="back_to_add_request"
                                >
                                  تعديل بيانات الطلب{" "}
                                </button>
                              </>
                            )}
                          </>
                        )}
                        {!isSubmitting && !showSucessMessage && (
                          <button
                            onClick={() => {
                              navigate("/tax-appeal/list-data", {
                                state:
                                  location.pathname === "/tax-appeal/temporary"
                                    ? { message: "تم إلغاء تقديم الطلب" }
                                    : "",
                              });
                            }}
                            className={` ${stylesRequestData["btn-login"]} ${
                              id && "w-25"
                            }`}
                            id="cancel_request_data"
                          >
                            {id ? "العودة إلى قائمة طلبات الطعن" : "إلغاء"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </MainContent>
      {/* )} */}
    </>
  );
};
export default UnifiedTaxDeclarationDetails;
